import {combineReducers} from 'redux';
import {alert} from './alertRedu';
import {authenticationRedu} from './authenticationRedu';
import {userRedu} from './userRedu';
import {storeRedu} from './storeRedu';
import {customerGroupRedu} from './customerGroupRedu';
import {customerRedu} from "./customerRedu";
import {staffRedu} from "./staffRedu";
import {promoRedu} from "./promoRedu";
import {serviceRedu} from "./serviceRedu";
import {imageRedu} from "./imageRedu";
import {billRedu} from "./billRedu";
import {feedbackRedu} from "./feedbackRedu";
import {appointmentRedu} from "./appointmentRedu";
import {messageRedu} from "./messageRedu";

const rootReducer = combineReducers({
  alert,
  authRedu: authenticationRedu,
  storeRedu,
  messageRedu
});

export default rootReducer;
